// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Ras","cls2":"ProfilePdfPackCard-cls2_Bhv ProfilePdfPackCard-cls1_Ras"};